import intermind, { BillingCycle } from '../../../index';
import { Invoice, ListParams, ListResponse, Payment, Subscription } from '../../../types';

export class AdminBillingResource {
  async subscriptions(userId: string, params: ListParams): Promise<ListResponse<Subscription>> {
    const { data } = await intermind.httpClient.get<ListResponse<Subscription>>(
      `/admin/users/${userId}/subscriptions`,
      {
        params,
      }
    );
    return data;
  }

  async invoices(userId: string, params: ListParams): Promise<ListResponse<Invoice>> {
    const { data } = await intermind.httpClient.get<ListResponse<Invoice>>(`/admin/users/${userId}/invoices`, {
      params,
    });
    return data;
  }

  async payments(userId: string, params: ListParams): Promise<ListResponse<Payment>> {
    const { data } = await intermind.httpClient.get<ListResponse<Payment>>(`/admin/users/${userId}/payments`, {
      params,
    });
    return data;
  }

  async cancelSubscription(subscriptionId: string, force?: boolean): Promise<void> {
    await intermind.httpClient.post(`/admin/subscriptions/${subscriptionId}/cancel`, { force: force ?? false });
  }

  async addSubscription(userId: string, planId: string, cycle: BillingCycle): Promise<Subscription> {
    const { data } = await intermind.httpClient.post<Subscription>(`/admin/users/${userId}/subscriptions`, {
      planId,
      cycle,
    });
    return data;
  }
}
